export interface Alert {
  userAlertDistributionID: number;
  createdDate: string;
  sendTimeEST: string;
  subject: string;
  isRead: boolean;
  readCount: number;
}

export enum AlertActions {
  MARK_AS_READ = 1,
  GET_NEW = 2
}

export interface IAlertNotification {
  alerts?: Array<Alert>;
  action: AlertActions;
}

export interface IAlertsQueryParams {
  channel?: string;
  page?: number;
  deleted?: boolean;
  size?: number;
  sortedfield?: string;
  sortorder?: string;
  detail?: string;
  readcount?: number;
}

export interface AlertsConfig {
  alertMessagesUrl?: string;
  alertCountUrl?: string;
}
